import { quizLegendText } from '~/training/sequence/templates/translators/itemHelpers/Quiz';
import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import {
  LayoutColumnsDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  QUIZ_CHOICE,
  TEXT,
  FBPOST
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import {
  addTargetBlankToLinks,
  removeEmptyTags
} from '~/training/sequence/templates/translators/itemHelpers/TextHelper';

export const SocialMedia8: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        columns.items.push({
          type: FBPOST,
          id: item.id,
          values: {
            avatar:
              sequence.personalization && sequence.logoUrl
                ? sequence.logoUrl
                : item?.pictures && item?.pictures.length >= 0
                  ? item?.pictures[0]?.mediaUrl
                  : false,
            pic:
              item?.pictures && item?.pictures.length >= 1
                ? item?.pictures[1]?.mediaUrl
                : false,
            nameEditable: !(sequence.personalization && sequence.companyName),
            name:
              sequence.personalization && sequence.companyName
                ? '@' + sequence.companyName.replace(/ /g, '')
                : item?.subtitle || 'Username',
            title: item?.title || 'Title',
            body: item?.body
              ? removeEmptyTags(
                  '<span>' +
                    addTargetBlankToLinks(item?.body.replace(/<\/?div>/g, '')) +
                    '</span>'
                )
              : 'Body'
          },
          items: []
        });
        break;
      case 'Question':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `subtitle_${item.id}`,
              items: [],
              values: {
                value: item.subtitle || 'QUIZ',
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `title_${item.id}`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `body_${item.id}`,
              items: [],
              values: {
                value: item.body
              }
            },
            {
              type: QUIZ_CHOICE,
              id: '1',
              values: {
                variant: item.items && item.items.length > 2 ? 'list' : '',
                title: quizLegendText(item.title, item.body),
                length: item?.items?.length,
                multiSelect: item?.items?.filter(item => item.correct === true)
                  .length
              },
              items: AnswerButtonHelper({
                group: item.id,
                items: item.items,
                llamaSurvey: item.llamaSurvey,
                question: item.title || ''
              })
            }
          ]
        });
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
